import React, { Component } from 'react';

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class JournalEntryModal extends Component {

    render() {
        const { detailsJournalEntry, CloseJournalEntryModal } = this.props;
        
        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="journalEntryModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="searchSucursalModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Detalle depósitos bancarios</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseJournalEntryModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tr>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Cuenta</td>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Nombre cuenta</td>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Débito</td>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Crédito</td>
                                                </tr>
                                                {!!detailsJournalEntry && detailsJournalEntry.map((journal, index) => {                                                    
                                                    return(
                                                        <tr key={index}>                                                            
                                                            <td>{journal.Account}</td>
                                                            <td>{journal.AcctName}</td>
                                                            <td>{formatNumber.new(journal.Debit)}</td>
                                                            <td>{formatNumber.new(journal.Credit)}</td>
                                                        </tr>                                  
                                                    )
                                                })}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={CloseJournalEntryModal}>
                                    Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default JournalEntryModal;